export default __webpack_public_path__ + "static/media/WAND.44017814.png";